import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer/footer";
import ButtonWithSVG from "../../Components/layouts/button_with_svg";
import StepRoutes from "../../Routes/steps_routes";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import Pagination from "../../Components/layouts/pagination";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import LoadingPage from "../../Components/layouts/loading";
import { useSelector } from "react-redux";
import PaymentTrackingTable from "./Payment Tracking/payment_tracking_table";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { FcCurrencyExchange } from "react-icons/fc";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";

const ClientPaymentTracking = () => {
  const user = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [leadOwner, setLeadOwner] = useState([]);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    leadname: "",
    leadowner: "",
    project: "",
  });
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const store = useSelector((store) => store.login.user);
  const [projects, setProjects] = useState([]);
  const [themeSet, setThemeSet] = useState("");
  const [searchParams] = useSearchParams();
  const theme = searchParams.get("theme");

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageFromUrl = parseInt(params.get("page")) || 1;
    setPage(pageFromUrl);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set("page", page);
    navigate({ search: params.toString() }, { replace: true });
  }, [page]);

  useEffect(() => {
    setThemeSet(theme);
  }, [theme]);

  useEffect(() => {
    performRequest("GET", "/clientProject/getCpName/")
      .then((res) => setProjects(res.data.clientProjectsData))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setLeadOwner(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  useEffect(() => {
    setLoading(true);

    performRequest(
      "GET",
      getFilteredURL("/paymentTracking/getPaymentTracking", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(Math.ceil(res.data?.paymentTrackingCount / 50));
        } else {
          Toast("error", "Error while getting details!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);
  // useEffect(() => {
  //   performRequest("GET", "/leads/getAllLeadsOwners")
  //     .then((res) => setLeadOwner(res.data))
  //     .catch((err) => console.error(err));
  // }, []);
  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title">
                  <FcCurrencyExchange className="fs-2 me-1" />
                  Payment Tracking
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
              {user.Role !== process.env.REACT_APP_ROLE_CLIENT &&
                user.Role !== process.env.REACT_APP_ROLE_D_CLIENT && (
                  <div className="col-auto ms-auto d-print-none">
                    <div className="d-flex d-none d-sm-block">
                      <ButtonWithSVG
                        href={"/client-payment-tracking/new"}
                        buttonText="New Payment Tracking"
                        svg={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M12 5l0 14" />
                            <path d="M5 12l14 0" />
                          </svg>
                        }
                      />
                    </div>
                  </div>
                )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div
                        className={`accordion-body pt-0 ${
                          themeSet === "dark" ? "text-light" : ""
                        }`}
                      >
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Start Date:"
                              value={filters.startdate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  startdate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="End Date:"
                              value={filters.enddate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  enddate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Search name:"
                              value={filters.leadname}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  leadname: e.target.value,
                                })
                              }
                              placeholder="search name..."
                            />
                          </div>
                          <div className="col-12">
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Search lead owner:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    leadowner: e.target.value,
                                  })
                                }
                                value={filters.leadowner}
                              >
                                <option value="">select all</option>
                                {leadOwner &&
                                  leadOwner?.map((lead, index) => {
                                    return (
                                      <option
                                        key={index}
                                        value={lead?.userName}
                                      >
                                        {lead?.userName}
                                      </option>
                                    );
                                  })}
                              </DynamicFilterSelect>
                            </div>
                          </div>
                          {(store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                            store.Role ===
                              process.env.REACT_APP_ROLE_ADMIN) && (
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Search project:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    project: e.target.value,
                                  })
                                }
                                value={filters.project}
                              >
                                <option value="">select all</option>

                                {projects &&
                                  projects?.map((state, index) => (
                                    <option
                                      key={index}
                                      value={state?.clientName}
                                    >
                                      {state?.clientName}
                                    </option>
                                  ))}
                              </DynamicFilterSelect>
                            </div>
                          )}

                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      startdate: "",
                                      enddate: "",
                                      leadname: "",
                                      leadowner: "",
                                      project: "",
                                    });
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className={`accordion-body d-none d-md-block ${
                        themeSet === "dark" ? "text-light" : ""
                      }`}
                    >
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="Start Date:"
                            value={filters.startdate}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                startdate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="End Date:"
                            value={filters.enddate}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                enddate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="Search name:"
                            value={filters.leadname}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                leadname: e.target.value,
                              })
                            }
                            placeholder="search name..."
                          />
                        </div>
                        <div className="col-12">
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Search lead owner:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  leadowner: e.target.value,
                                })
                              }
                              value={filters.leadowner}
                            >
                              <option value="">select all</option>
                              {leadOwner &&
                                leadOwner?.map((lead, index) => {
                                  return (
                                    <option key={index} value={lead?.userName}>
                                      {lead?.userName}
                                    </option>
                                  );
                                })}
                            </DynamicFilterSelect>
                          </div>
                        </div>
                        {(store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                          store.Role === process.env.REACT_APP_ROLE_ADMIN) && (
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Search project:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  project: e.target.value,
                                })
                              }
                              value={filters.project}
                            >
                              <option value="">select all</option>

                              {projects &&
                                projects?.map((state, index) => (
                                  <option key={index} value={state?.clientName}>
                                    {state?.clientName}
                                  </option>
                                ))}
                            </DynamicFilterSelect>
                          </div>
                        )}

                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    startdate: "",
                                    enddate: "",
                                    leadname: "",
                                    leadowner: "",
                                    project: "",
                                  });
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                {data &&
                data?.paymentTrackingData &&
                data?.paymentTrackingData.length > 0 ? (
                  <PaymentTrackingTable
                    PT={data?.paymentTrackingData}
                    currentPage={page}
                    itemsPerPage={50}
                  />
                ) : (
                  <div>
                    <h2 className="text-center p-4">
                      Work order is not yet uploaded kindly make advance payment
                      to start the project.
                    </h2>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <div className="">
                        <h2 className="text-center text-lg-start text-md-start">
                          Payment Details:
                        </h2>
                        <h3 className="text-center text-lg-start text-md-start">
                          Name: KRYZEN BIOTECH PRIVATE LIMITED
                        </h3>
                        <h3 className="text-center text-lg-start text-md-start">
                          Bank: ICICI BANK
                        </h3>
                        <h3 className="text-center text-lg-start text-md-start">
                          Account No.: 016905015915
                        </h3>
                        <h3 className="text-center text-lg-start text-md-start">
                          IFSC: ICIC0007565
                        </h3>
                      </div>
                      <div className="text-center text-lg-start text-md-start">
                        <img
                          src={
                            "https://res.cloudinary.com/bsgfcooa/image/upload/v1753080572/QrCode_tem4c0_i3godi_axhqdz.jpg"
                          }
                          alt="Qr code"
                          style={{ height: "200px", width: "200px" }}
                        ></img>
                      </div>
                    </div>
                  </div>
                )}

                {user.Role !== process.env.REACT_APP_ROLE_CLIENT &&
                  user.Role !== process.env.REACT_APP_ROLE_D_CLIENT && (
                    <div className="btn-list justify-content-center">
                      <div className=" d-lg-none d-md-none mt-3 mb-3">
                        <ButtonWithSVG
                          href={"/client-payment-tracking/new"}
                          buttonText="New Payment Tracking"
                          svg={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              strokeWidth="2"
                              stroke="currentColor"
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M12 5l0 14" />
                              <path d="M5 12l14 0" />
                            </svg>
                          }
                        />
                      </div>
                    </div>
                  )}
                {data &&
                  data?.paymentTrackingData &&
                  data?.paymentTrackingData.length > 0 && (
                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.paymentTrackingData?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  )}
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ClientPaymentTracking;
